import { useState, useEffect } from 'react';
import Modal from "react-modal";

const ExpiryModal = ({ isOpen, onClose }) => {
    
    useEffect(() => {
        if (!isOpen) return;

        const handleEsc = (e) => {
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Success Modal"
            className="modal-sm success-modal p-5"
        >
            <div className="d-flex flex-column align-items-center">
                <div className="mb-3">
                    <p className="font-xxl extraBold text-center">Session Expired!</p>
                </div>
                <div className="mb-3">
                    <p className="font-sm extraBold text-center">Your session has expired. Please login again</p>
                </div>
                <div>
                    <button
                        className="btn btn-primary"
                        onClick={onClose}
                        autoFocus
                    >
                        <span className="font-lg font-bold px-5">OK</span>
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default ExpiryModal;